module.exports = __webpack_public_path__ + "fonts/fa-brands-400---088a34f78f530102fd9661173b4a4f26.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.eot
// module id = 135
// module chunks = 0